import { atom } from "jotai";
import { DataSchema } from "common";

type NotLoginState = { type: "NotLogin" };
type ForbiddenState = { type: "Forbidden" };
type LoadingState = { type: "Loading" };

type LoggedInState = {
  type: "LoggedIn";
  user: DataSchema.AuthUser;
};

export type AuthState = NotLoginState | ForbiddenState | LoadingState | LoggedInState;

export const authAtom = atom<AuthState>({
  type: "Loading",
});
